// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__11lPm","legacyBtn":"MutateMid_legacyBtn__3vInt"};